/* eslint-disable @typescript-eslint/no-explicit-any */
export const isEmptyObject = (obj: object) => Object.keys(obj).length === 0

export const getEnumKeyByEnumValue = <E>(myEnum: object, key: E) =>
  Object.keys(myEnum)[Object.values(myEnum).indexOf(key)]

// Converts all keys´s first letters to lowercase
export const convertObjectKeysToLowercase = (obj: any): object => {
  if (Array.isArray(obj)) {
    // If it's an array, recursively process each element in the array
    return obj.map((item) => convertObjectKeysToLowercase(item))
  } else if (typeof obj === 'object' && obj !== null) {
    // If it's an object, recursively process each key-value pair
    const newObj: { [key: string]: any } = {}
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const newKey = key.charAt(0).toLowerCase() + key.slice(1)
        newObj[newKey] = convertObjectKeysToLowercase(obj[key])
      }
    }
    return newObj
  } else {
    // If it's neither an object nor an array, return it as is
    return obj
  }
}
